var loadCount = 0; 
function showLoadIcon(){
    ++loadCount;
}

function hideLoadIcon(){
    --loadCount;
    return loadCount;
}

export {hideLoadIcon,showLoadIcon}